module.exports = __webpack_public_path__ + "static/sport/login-success.9f5f896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/login-success.png
// module id = Ksrj
// module chunks = 0